import { useAuth } from '../../contexts/AuthContext'
import USER_TYPE from '../../constants/userType'

export default function DisplayForUserType({ children, userTypes }) {
  const { currentUser } = useAuth()
  const currentUserType = currentUser?.userType || USER_TYPE.guest

  if (!userTypes.includes(currentUserType)) {
    return null
  }

  return children
}
